import React from "react"
import PropTypes from "prop-types"

class Connects extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      responded: false
    }
  }

  renderConnects() {
    return this.props.connectedUsers.map((connect, i) => {
      const connectUser = (this.props.currentUserId === connect.requestor_id ? connect.requestee : connect.requestor)
      return(
        <button
          key={i}
          onClick={() => window.location.assign(`/profile/${connectUser.slug}`)}
          style={{
            cursor: 'pointer'
          }}>
          <img
            src={(connectUser.avatar_url === "medium/missing.png") ? this.props.missingImg : connectUser.avatar_url}
            style={{
              borderRadius: 30,
              height: 60,
              width: 60,
              cursor: 'pointer'
            }}
          />
        </button>
      )
    })
  }

  renderPlaceHolders() {
    return(
      <div style={{display: 'flex', flexDirection: 'row'}}>
        <div style={{backgroundColor: '#D7D8DA', width: 60, height: 60, borderRadius: 100, marginLeft: 5}}>
        </div>
        <div style={{backgroundColor: '#D7D8DA', width: 60, height: 60, borderRadius: 100, marginLeft: 5}}>
        </div>
        <div style={{backgroundColor: '#D7D8DA', width: 60, height: 60, borderRadius: 100, marginLeft: 5}}>
        </div>
      </div>
    )
  }

  render() {
    return(
      <div style={{}}>
        <div style={{display: 'flex', flexDirection: 'row', marginTop: 12, marginBottom: 24, flexWrap: 'wrap'}}>
          <img
            onClick={() => window.location.assign(`/friends`)}
            style={{width: 60, height: 60, borderRadius: 100, cursor: 'pointer'}}
            src={this.props.acceptRequestIcon} />
          {this.props.connectedUsers.length === 0 && this.renderPlaceHolders()}
          {this.renderConnects()}
        </div>
      </div>
    )
  }

}

export default Connects;
